<script>
/**
 * ****************************************************************************
 * @description     :   Component for show layout loading
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import { mapState } from 'vuex';

/**
 * Import template
 */
import template from './template.html';

/**
 * Define component chat for show page chat
 */
var Loading = {
    template: template,
    computed: {
        ...mapState('app', ['isLoading', 'isForceLoading', 'isNoLoading'])
    }
};
export default Loading;
</script>
